import { useState, useEffect } from 'react';
import { WorkshiftTypeModel } from '../../../../../models';
import { WorkshiftsAPI } from '../../../../../services/external/APIs';
import AsyncSelect from 'react-select/async';
import { BaseSelector } from '../../../../../models/baseSelector';

interface WorkshiftSelectorProps {
    name: string;
    disable?: boolean;
    onChange: (name: string, value: string | null | number | undefined) => void;
    value: string | undefined | number;
}

export const WorkshiftSelector = ({
    name,
    onChange,
    disable = false,
    value,
}: WorkshiftSelectorProps) => {
    const [workshiftList, setWorkshiftList] = useState<BaseSelector[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        WorkshiftsAPI.getAllWorkshiftsList()
            .then((res) => {
                const convertedResponse = res.map((item) => {
                    return {
                        label: item.name,
                        value: item.id,
                    };
                });
                setWorkshiftList(convertedResponse);
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }, []);

    const filterName = (inputValue: string) => {
        return workshiftList.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadOptions = (
        inputValue: string,
        callback: (options: BaseSelector[]) => void
    ) => {
        setTimeout(() => {
            callback(filterName(inputValue));
        }, 1000);
    };

    return (
        <AsyncSelect
            isLoading={isLoadingData}
            onChange={(e) => {
                onChange(name, e?.value);
            }}
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions={workshiftList}
            name='destiny-selector'
            placeholder={`Seleccione...`}
            className='flex-1'
            isDisabled={disable}
            value={
                workshiftList.find((a) => a.value === value) ?? {
                    label: `Seleccione...`,
                    value: 0,
                }
            }
        />
    );
};
